import React from "react"

import { Stack, Typography, useTheme } from "@mui/material"
import BankerGroups from "components/module/banker/groupsView/BankerGroups"
import { useIsBreakpointUp } from "hooks/breakpoint"
import { useClassId } from "hooks/navigation"
import StudentsGroupsSwitch from "layout/teacherStudentsLayout/StudentsGroupsSwitch"
import { useTranslation } from "react-i18next"
import { matchPath, useLocation } from "react-router"
import { RoutePath } from "routes/Route.types"

import TableView from "./tableView"

// Banker's Groups grid now runs on real BED endpoints (ticket 15) — re-enabled after
// ticket 14 left the switch/route unreachable pending the banker-scoped endpoints.
const Banker = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isTablet = useIsBreakpointUp("tablet")
  const classId = useClassId()
  const { pathname } = useLocation()
  const isGroups = !!matchPath(RoutePath.CLASS_BANKER_GROUPS, pathname)

  return (
    <Stack>
      <Stack
        flexDirection="row"
        alignItems="center"
        sx={{ backgroundColor: theme.palette.common.white, mb: 2, p: 2 }}
      >
        <Typography fontSize="28px" flex="0 0 300px">
          {t("layout.sendTransactions")}
        </Typography>
        {isTablet && (
          <Typography variant="subtitle2" fontWeight="500" flex="1 1 0">
            You’ve been assigned as a Student Banker. This means you now have
            the ability to send transactions to students. Remember, all
            transactions you make will have your name on them, so stay
            trustworthy!
          </Typography>
        )}
      </Stack>
      <StudentsGroupsSwitch
        classId={classId}
        isGroups={isGroups}
        studentsPath={RoutePath.CLASS_BANKER}
        groupsPath={RoutePath.CLASS_BANKER_GROUPS}
      />
      {isGroups ? <BankerGroups /> : <TableView />}
    </Stack>
  )
}
export default Banker
